var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunchingIcon1(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.471,
    height: 123.872,
    viewBox: "0 0 156.471 123.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4470",
    "data-name": "Group 4470",
    transform: "translate(-636 -642.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M46.282,6.736a12.754,12.754,0,0,0-18.041,0L25.784,9.194,23.326,6.736A12.757,12.757,0,0,0,5.285,24.776l2.458,2.458L25.784,45.275,43.824,27.234l2.458-2.458a12.754,12.754,0,0,0,0-18.041Z",
    transform: "translate(739.451 672.502)",
    fill: "none",
    stroke: "#dd1ac3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-check_1_",
    "data-name": "user-check (1)",
    transform: "translate(640 646.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M97.56,53.624V40.749A25.749,25.749,0,0,0,71.811,15H26.749A25.749,25.749,0,0,0,1,40.749V53.624",
    transform: "translate(-1 62.248)",
    fill: "none",
    stroke: "#dd1ac3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 25.749,
    cy: 25.749,
    rx: 25.749,
    ry: 25.749,
    transform: "translate(22.53 0)",
    fill: "none",
    stroke: "#dd1ac3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchingIcon1);
export default __webpack_public_path__ + "static/media/launching-icon1.b3e688308a1cbff413f4c52562716231.svg";
export { ForwardRef as ReactComponent };